import NotFound from './NotFound.vue'
export default {
    path:'*', component: NotFound
}